import iFrameResize from 'iframe-resizer';
import interact from 'interactjs';

export default function() {
    return {
        loading: true,
        resizing: false,
        width: '100%',
        init() {
            const [iframe] = iFrameResize.iframeResizer(
                {
                    scrolling: 'omit',
                    checkOrigin: false,
                    resizeFrom: 'child',
                },
                this.$refs.iframe
            );

            interact(this.$refs.root)
                .resizable({
                    invert: 'none',
                    edges: {
                        top: false,
                        left: false,
                        bottom: false,
                        right: this.$refs.handle,
                    },
                    modifiers: [
                        interact.modifiers.restrictSize({
                            min: {
                                width: 336,
                            },
                        }),
                        interact.modifiers.restrictEdges({
                            outer: 'parent',
                        }),
                    ],
                })
                .on('resizestart', e => {
                    this.resizing = true;
                })
                .on('resizeend', e => {
                    this.resizing = false;
                    if (
                        e.rect.width ===
                        this.$refs.root.parentElement.clientWidth
                    ) {
                        this.width = '100%';
                    }
                })
                .on('resizemove', e => {
                    this.width = `${e.rect.width}px`;
                    iframe.iFrameResizer.resize();
                });

            this.$refs.iframe.contentWindow.addEventListener(
                'DOMContentLoaded',
                () => {
                    this.loading = false;
                }
            );
        },
    };
}
